import { FaLock } from 'react-icons/fa';

export default function NotAuthorized() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
      <FaLock className="text-6xl text-red-600 mb-6" />
      <h1 className="text-4xl font-bold text-gray-800 mb-4">403 — Access Denied</h1>
      <p className="text-gray-600 mb-8 text-center max-w-md">
        You don’t have permission to view this page. Please contact your administrator if you believe this is an error.
      </p>
      <a
        href="/"
        className="px-6 py-3 bg-primary-400 text-white rounded-full font-medium hover:bg-primary-500 transition"
      >
        Back to Home
      </a>
    </div>
  );
}
